const flowActionTypes = {
  FETCH_FLOW_STEPS_REQUEST: 'FETCH_FLOW_STEPS_REQUEST',
  FETCH_FLOW_STEPS_SUCCESS: 'FETCH_FLOW_STEPS_SUCCESS',
  FETCH_FLOW_STEPS_FAILURE: 'FETCH_FLOW_STEPS_FAILURE'
};

export default flowActionTypes;
